import React from 'react';

import { unCamelCase } from './../../helpers/camelCase';

import { TextField } from '@material-ui/core';

import moment from 'moment';

const EditableDateInput = ({ data, setData, labels }) => {
  return labels.map(label => (
    <TextField
      key={label}
      data-testid="inputEdit"
      type={'datetime-local'}
      InputLabelProps={{ shrink: true }}
      label={unCamelCase(label)}
      value={moment(data[label]).format('YYYY-MM-DDTHH:mm')}
      onChange={e => {
        setData({ ...data, [label]: e.target.value });
      }}
    />
  ));
};

export default EditableDateInput;
